import React from 'react';
import styled from 'styled-components';
import {BasketItemSkeleton} from './BasketItemSkeleton';
import {SkeletonBlock} from '../../../../atoms/Skeletons/SkeletonBlock';

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const DeliveriesSkeleton = () => {
  return (
    <Wrapper>
      <DeliveriesTitleSkeleton $width="30%" disableSpaceBelow />
      <BasketItemSkeleton />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  padding: 1rem 1rem 0;
  border-bottom: 8px;
`;

const DeliveriesTitleSkeleton = styled(SkeletonBlock)`
  height: 1.15rem;
`;
